export let mayAbbreviatedLowercase = "j_hDt";
export default {mayAbbreviatedLowercase};